export const buildMode = import.meta.env.MODE;
export const buildVersion = import.meta.env.VITE_BUILD_VERSION || "";
export const cloudflareSiteKey =
  import.meta.env.VITE_CLOUDFLARE_SITE_KEY ||
  "0x4AAAAAAA5hIdOeaMttZXUR";
